<template>
  <VueDatePicker
    ref="datePickerRef"
    v-model="date"
    :min-date="minDate"
    :start-date="startDate"
    range
    :enable-time-picker="false"
    cancel-text="Очистить"
    select-text="Применить"
    locale="ru"
    :teleport="true"
    position="right"
    :allowed-dates="allowedDates"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
    <template #action-row="{ internalModelValue }">
      <div class="dp__action_buttons">
        <button
          class="dp__action_button dp__action_cancel"
          :disabled="
            !internalModelValue
              || internalModelValue.length === 0
              || !internalModelValue[0]
          "
          @click="clearDates"
        >
          Очистить
        </button>
        <button
          class="dp__action_button dp__action_select"
          :disabled="
            !internalModelValue
              || internalModelValue.length === 0
              || !internalModelValue[0]
          "
          @click="handleDate(internalModelValue)"
        >
          Применить
        </button>
      </div>
    </template>
  </VueDatePicker>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import dayjs from 'dayjs';

const emit = defineEmits(['on-date-select']);
const props = defineProps({
  minDate: {
    type: Date,
    default: new Date(),
  },
  startDate: {
    type: Date,
    default: new Date(),
  },
  modelValue: {
    type: Array,
    required: true,
  },
  activeDates: {
    type: Array,
    default() {
      return [];
    },
  },
});

const date = ref(props.modelValue);
const datePickerRef = ref(null);

const allowedDates = computed(() => props.activeDates.map((timestamp) => dayjs(timestamp * 1000)));

const handleDate = (modelData) => {
  datePickerRef?.value?.closeMenu();
  const formatedDates = [];
  date.value = modelData;

  for (let i = 0; i < modelData.length; i += 1) {
    if (modelData[i]) {
      formatedDates.push({
        date: dayjs(modelData[i]),
      });
    }
  }

  emit('on-date-select', formatedDates);
};

const clearDates = () => {
  datePickerRef?.value?.closeMenu();
  if (date.value.length) {
    emit('on-date-select', []);
  }
  date.value = [];
};

watch(
  () => props.modelValue,
  (newValue) => {
    date.value = newValue;
  },
);
</script>

<style lang="scss">
@import "../../styles/utils/variables.scss";
.dp__selection_preview {
  display: none !important;
}

.dp__theme_light {
  --dp-primary-color: #FF6F31;
  --dp-primary-disabled-color: $light-gray;
  --dp-font-family: "Onest", sans-serif;
  --dp-cell-size: 32px;
  --dp-cell-padding: 0;
}

.dp__month_year_wrap {
  justify-content: center;
  gap: 10px;
  font-weight: 700;

  button {
    width: auto;
  }
}

.dp__arrow_top {
  display: none;
}

.dp__range {
  &_start, &_end {
    border-radius: 4px;
    color: $white;
  }
}

.dp__menu {
  border-radius: 16px;
}

.dp--menu-wrapper {
  z-index: 11;
}

.dp__today {
  border: 1px solid $gray-medium;
}

.dp__action_buttons {
  margin-left: 0;
  width: 100%;
  flex: 1;
  gap: 16px;

  button {
    flex: 1;
    padding: 7px;
    font-size: 14px;
    border-radius: 16px;
    height: auto;
    line-height: 16px;
    text-align: center;
    justify-content: center;
  }
}

.dp__calendar_header_item {
  color: $gray;

  &:nth-child(6), &:nth-child(7) {
    color: $background-second;
  }
}

.dp__cell_disabled {
  &.dp--future {
    background-color: $light-gray;
    color: $gray-medium;
  }
}

.dp__cell_inner {
  margin: 8px 7px;
}

.dp__action_cancel {
  border-color: $black;
}

.dp__action_buttons .dp__action_select:disabled,
.dp__action_buttons .dp__action_cancel:disabled  {
  color: $gray-medium;
  background-color: $light-gray;
  border: none;
}
</style>
